(ns ui.date-time
  (:require
   [applied-science.js-interop :as js-interop]
   [re-posh.core :as re-posh]
   [ui.utils :refer [clsx]]
   [ui.tooltip :refer [tooltip]]
   [minorodata.app.utils :as app.utils]))

(def get-browser-timezone
  "The browser's timezone, resolved once per session."
  (memoize
   (fn []
     (-> js/Intl
         (js-interop/call :DateTimeFormat)
         (js-interop/call :resolvedOptions)
         (js-interop/get  :timeZone)))))


(defn date-text
  "`date-tooltip`'s trigger without the tooltip, for lists rendering many dates."
  [{:keys [date timezone class seconds?]}]
  (let [tz (or timezone
               @(re-posh/subscribe [:app.subs/timezone])
               (get-browser-timezone))]
    [:span {:class class
            :title (app.utils/format-date date {:timezone-to tz
                                                :as-iso?     true
                                                :seconds?    seconds?})}
     (app.utils/format-date date {:timezone-to tz :seconds? seconds?})]))

(defn date-tooltip
  "Formatted date with a three-timezone breakdown on hover.

  `time-only?` drops the day from the trigger, for a column whose date is
  already carried by a neighbouring one. Only the trigger changes — the tooltip
  still spells out the full date, so it is never more than a hover away."
  [{:keys [date timezone class skip-utc? seconds? time-only?]}]
  (let [client-timezone  (or timezone
                             @(re-posh/subscribe [:app.subs/timezone]))

        ;; Intl.DateTimeFormat().resolvedOptions().timeZone
        current-timezone (get-browser-timezone)

        utc "Etc/UTC"

        trigger-format   (when time-only?
                           (let [pattern (if seconds? "HH:mm:ss" "HH:mm")]
                             {:today pattern :yesterday pattern :date pattern}))]
    [tooltip
     {:class "min-w-[200px] w-full max-w-[500px]"
      :content
      [:div {:class "text-xs grid grid-cols-[min-content_min-content_1fr] gap-y-1"}

       [:div {:class ["border-solid border-0 border-b border-kleene-neutral-05 dark:border-kleene-dark-03 mb-2"
                      "text-kleene-dark-04 dark:text-kleene-dark-0"]}
        "Timezone"]
       [:div {:class "border-solid border-0 border-b border-kleene-neutral-05 dark:border-kleene-dark-03 mb-2"}]
       [:div {:class "border-solid border-0 border-b border-kleene-neutral-05 dark:border-kleene-dark-03 mb-2"}]


       [:div {:class "whitespace-nowrap"}
        client-timezone]
       [:span {:class "text-kleene-dark-04 dark:text-kleene-dark-0 text-xs ml-2"}
        "System"]
       [:div {:title (app.utils/format-date date {:timezone-to client-timezone :as-iso? true :seconds? seconds?})
              :class "ml-3 cursor-help"}
        (app.utils/format-date date {:timezone-to client-timezone :seconds? seconds?})]


       [:div
        current-timezone]
       [:span {:class "text-kleene-dark-04 dark:text-kleene-dark-0 text-xs ml-2"}
        "Local"]
       [:div {:title (app.utils/format-date date {:timezone-to current-timezone :as-iso? true :seconds? seconds?})
              :class "ml-3 cursor-help"}
        (app.utils/format-date date {:timezone-to current-timezone :seconds? seconds?})]

       (when-not skip-utc?
         [:<>
          [:div "UTC"]
          [:span]
          [:div {:title (app.utils/format-date date {:timezone-to utc :as-iso? true :seconds? seconds?})
                 :class "ml-3 cursor-help"}
           (app.utils/format-date date {:timezone-to utc :seconds? seconds?})]])]}

     [:span {:class (clsx "cursor-help" class)}
      (app.utils/format-date date (merge {:timezone-to (or client-timezone current-timezone)
                                          :seconds?    seconds?}
                                         trigger-format))]]))
